
import React from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EnhancedOffer } from '@/lib/api/offers/types';

interface UserOffersTabProps {
  isLoading: boolean;
  userOffers?: EnhancedOffer[];
}

export const UserOffersTab = ({ isLoading, userOffers }: UserOffersTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>All Offers</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center py-10">
            <Loader2 className="h-6 w-6 animate-spin" />
          </div>
        ) : userOffers && userOffers.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {userOffers.map((offer) => (
              <div key={offer.id} className="border rounded-lg overflow-hidden">
                <div className="p-4">
                  <h3 className="font-medium mb-2">{offer.title}</h3>
                  <div className="flex flex-wrap gap-2 mb-3">
                    <Badge variant="outline">{offer.link_type}</Badge>
                    {offer.tags && offer.tags.map((tag, i) => (
                      <Badge key={i} variant="secondary">{tag}</Badge>
                    ))}
                  </div>
                  <div className="flex justify-between text-sm mb-3">
                    <span>DR {offer.dr}</span>
                    <span>DA {offer.da}</span>
                    <span>{offer.traffic_estimate} visits/mo</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-bold">${offer.price_cents / 100}</span>
                    <Button size="sm" asChild>
                      <Link to={`/offers/${offer.id}`}>
                        View Details
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-10 text-muted-foreground">
            This user hasn't created any offers yet
          </div>
        )}
      </CardContent>
    </Card>
  );
};
